export const testimonials = [
  {
    name: '阿柚子',
    role: '大三 · 新闻传播',
    text: '睡前刷两篇，像又回到大一熄灯后和室友聊天的时候，评论区的分享比正文还好笑。',
  },
  {
    name: '小林同学',
    role: '大二 · 计算机',
    text: '本来只是来找乐子，结果被那篇图书馆占座的纸条看得有点鼻酸，写得很真诚。',
  },
  {
    name: '毕业两年的K',
    role: '已毕业 · 设计',
    text: '上班摸鱼时看，突然就想起自己的食堂窗口和社团群，回忆杀来得毫无防备。',
  },
  {
    name: '深夜读者',
    role: '大四 · 汉语言',
    text: '分类做得很清楚，我想看宿舍那类就直接点进去，不用一页页翻，体验很舒服。',
  },
  {
    name: '橙子汽水',
    role: '大二 · 会计',
    text: '已经在邮箱里等每日热瓜了，早上通勤看一眼，一天心情都不错。',
  },
  {
    name: '走廊常客',
    role: '研一 · 材料',
    text: '故事短小但有余味，最喜欢那句“同行的人会等你”，看完整个人都软下来了。',
  },
];